import type { NavKey } from './NavContext';

export const PATHS: Record<NavKey, string> = {
  dashboard: '/',
  floor: '/floor',
  reservations: '/reservations',
  orders: '/orders',
  menu: '/menu',
  support: '/support',
  guest: '/guest',
  settings: '/settings',
};

/** Reverse lookup, built once from PATHS. */
const KEYS_BY_PATH: Record<string, NavKey> = Object.fromEntries(
  Object.entries(PATHS).map(([key, path]) => [path, key as NavKey]),
) as Record<string, NavKey>;

/** Resolve a URL pathname to a nav tab; unknown paths (incl. stale auth routes) fall back to `dashboard`. */
export function keyFromPath(pathname: string): NavKey {
  return KEYS_BY_PATH[pathname] ?? 'dashboard';
}
